import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const JurnalPiket = ({ token, namaUser }) => {
  const [jurnal, setJurnal] = useState([]);
  const [form, setForm] = useState({ kejadian: '', penanganan: '', penulis: namaUser || '' });
  const [loading, setLoading] = useState(true);

  // Jika namaUser berganti/load dari parent, isi ke form otomatis
  useEffect(() => {
    if (namaUser) {
      setForm((prev) => ({ ...prev, penulis: namaUser }));
    }
  }, [namaUser]);

  useEffect(() => {
    fetchJurnal();
  }, []);

  const fetchJurnal = async () => {
    setLoading(true);
    try {
      // FIX: Gunakan relative path /api/jurnal
      const res = await axios.get('/api/jurnal', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setJurnal(res.data);
    } catch (err) {
      console.error("Gagal mengambil data jurnal:", err);
    }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // FIX: Gunakan relative path /api/jurnal
      await axios.post('/api/jurnal', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      Swal.fire('Tersimpan', 'Catatan jurnal piket berhasil disimpan', 'success');
      
      // Reset form tapi tetap pertahankan nama penulis
      setForm({ kejadian: '', penanganan: '', penulis: namaUser || '' });
      fetchJurnal();
    } catch (err) {
      console.error("Error submit jurnal:", err);
      Swal.fire('Gagal', 'Terjadi kesalahan saat menyimpan catatan.', 'error');
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Hapus Catatan?',
      text: "Catatan kejadian ini akan dihapus permanen.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, Hapus',
      cancelButtonText: 'Batal',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#64748b'
    });

    if (result.isConfirmed) {
      try {
        // FIX: Gunakan relative path /api/jurnal/:id
        await axios.delete(`/api/jurnal/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire('Terhapus', 'Catatan berhasil dihapus', 'success');
        fetchJurnal();
      } catch (e) {
        console.error("Error delete jurnal:", e);
        Swal.fire('Gagal', 'Gagal menghapus catatan jurnal.', 'error');
      }
    }
  };

  // Format Tanggal Indo
  const formatTanggal = (isoDate) => {
    if (!isoDate) return '-';
    return new Date(isoDate).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <h2 style={{ color: '#1e293b', marginBottom: '20px' }}>📖 Jurnal Piket Harian</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          
          {/* FORM INPUT */}
          <div style={{ background: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', height: 'fit-content' }}>
              <h4 style={{ margin: '0 0 20px', color: '#4361ee' }}>✍️ Catat Kejadian</h4>
              <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '15px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold', color: '#334155' }}>Kejadian / Peristiwa</label>
                      <textarea 
                        required
                        rows="3"
                        placeholder="Contoh: Siswa sakit di UKS, Ada tamu dinas, dll."
                        value={form.kejadian}
                        onChange={e => setForm({...form, kejadian: e.target.value})}
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }}
                      ></textarea>
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold', color: '#334155' }}>Tindakan / Penanganan</label>
                      <input 
                        type="text"
                        placeholder="Contoh: Diberi obat, Diizinkan pulang"
                        value={form.penanganan}
                        onChange={e => setForm({...form, penanganan: e.target.value})}
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }}
                      />
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold', color: '#334155' }}>Petugas Piket (Penulis)</label>
                      <input 
                        required
                        type="text"
                        placeholder="Nama Guru Piket"
                        value={form.penulis}
                        onChange={e => setForm({...form, penulis: e.target.value})}
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', boxSizing: 'border-box', background: '#f8fafc' }}
                      />
                  </div>
                  <button type="submit" style={{ width: '100%', padding: '12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
                      Simpan Catatan
                  </button>
              </form>
          </div>

          {/* LIST JURNAL */}
          <div>
              {loading ? <p style={{ color: '#64748b' }}>Memuat data jurnal...</p> : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                      {jurnal.length === 0 ? (
                        <div style={{ padding: '30px', background: 'white', borderRadius: '12px', textAlign: 'center', color: '#94a3b8', border: '1px dashed #cbd5e1' }}>
                          ☕ Belum ada catatan jurnal piket hari ini.
                        </div>
                      ) : (
                        jurnal.map((j) => (
                          <div key={j.id} style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', borderLeft: '5px solid #f59e0b', position: 'relative' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                  <span style={{ fontSize: '12px', background: '#fef3c7', padding: '3px 8px', borderRadius: '4px', color: '#b45309', fontWeight: 'bold' }}>
                                      📅 {formatTanggal(j.tanggal)} {j.jam && `• ⏰ ${j.jam.slice(0,5)}`}
                                  </span>
                                  <button onClick={() => handleDelete(j.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '16px' }} title="Hapus Catatan">
                                    🗑️
                                  </button>
                              </div>
                              <h3 style={{ margin: '0 0 8px', fontSize: '16px', color: '#1e293b' }}>{j.kejadian}</h3>
                              <p style={{ margin: '0 0 12px', fontSize: '14px', color: '#64748b' }}>➡ <b>Penanganan:</b> {j.penanganan || '-'}</p>
                              <div style={{ fontSize: '12px', color: '#94a3b8', borderTop: '1px dashed #e2e8f0', paddingTop: '8px' }}>
                                  ✍️ Ditulis oleh: <b>{j.penulis}</b>
                              </div>
                          </div>
                        ))
                      )}
                  </div>
              )}
          </div>

      </div>
    </div>
  );
};

export default JurnalPiket;